import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Data } from '@angular/router';
import { RoutingService } from '../../routing/services/routing.service';
import { SettingsService } from '../../settings/services/settings.service';

@Component({
  selector: 'app-redirect',
  template: 'redirecting...'
})
export class RedirectComponent implements OnInit {
    appSettings = this.settingsService.Get();

    private helpUrl = this.appSettings.helpUrl;
    private editorialUrl = this.appSettings.editorialUrl;

    constructor(private settingsService: SettingsService, private routingService: RoutingService, private route: ActivatedRoute) {
    }

    ngOnInit() {
        const urlTarget = this.route.snapshot.data['url'];
        let target = '';
        if (urlTarget === 'help') {
            target = this.helpUrl;
        } else {
            target = this.editorialUrl;
        }
        window.open(target, '_blank');
        this.routingService.routeToDashboard();
    }
}



// WEBPACK FOOTER //
// ./src/app/routing/components/redirect.component.ts